import Timer from 'easytimer.js';
import { UNITS, isValidLanternTimerUnit } from '../../constants/time';

export default class LanternTimer {
    constructor(name, units) {
        this.name = name;
        this.units = isValidLanternTimerUnit(units) ? units : UNITS.SECONDS;
        this.startCountdown = this.startCountdown.bind(this);
        this.startChronometer = this.startChronometer.bind(this);
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
        this.stop = this.stop.bind(this);
        this.getTime = this.getTime.bind(this);
    }

    /**
     * Start countdown timer from 0 to `timeDelay` and execute `callback` when it's achived
     */
    startCountdown(callback, timeDelay) {
        this.timer = new Timer();
        this.timer.addEventListener('targetAchieved', callback);
        this.timer.start({
            precision: this.units,
            target: { [this.units]: timeDelay },
        });
    }

    /**
     * Start timer from 0 till it's stoped
     */
    startChronometer() {
        this.timer = new Timer();
        this.timer.start({
            precision: this.units,
        });
    }

    pause() {
        this.timer.pause();
    }

    resume() {
        this.timer.start();
    }

    isRunning() {
        return this.timer.isRunning();
    }

    /**
     * Stop timer and return the amount of elapsed time in `units` till it stopped
     */
    stop() {
        const elapsedTime = this.getTime();
        this.timer.stop();
        return elapsedTime;
    }

    /**
     * Get elapsed time till this moment
     */
    getTime() {
        const elapsedTime = this.timer.getTotalTimeValues();
        return elapsedTime[this.units];
    }
}
